import type { Transaction } from "@rocicorp/zero";
import type { Context } from "./authorization";
import { branchRole } from "./branchRole";
import {
  type Schema,
  type Workflow,
  type WorkflowBranch,
  zql,
} from "./generatedDrizzleSchema";
import { actorColumns } from "./rbac/roles";

export async function inheritBranchContributors(
  tx: Transaction<Schema>,
  ctx: Context,
  source: Pick<WorkflowBranch, "id" | "name" | "userId" | "workflowId"> & {
    workflow: Pick<Workflow, "autofixBranchId" | "autoImproveBranchId">;
  },
  branchId: string
) {
  const existing = await tx.run(
    zql.branchContributors.where("branchId", branchId)
  );
  const contributors = new Map(
    existing.map((c) => [c.userId, c.lastMessagedAt])
  );

  if (source.name !== "main") {
    const inherited = await tx.run(
      zql.branchContributors.where("branchId", source.id)
    );
    for (const contributor of inherited) {
      const previous = contributors.get(contributor.userId);
      if (
        previous == null ||
        (contributor.lastMessagedAt !== null &&
          contributor.lastMessagedAt > previous)
      ) {
        contributors.set(contributor.userId, contributor.lastMessagedAt);
      }
    }
    if (
      source.userId &&
      !contributors.has(source.userId) &&
      branchRole(source) === "other"
    ) {
      contributors.set(source.userId, null);
    }
  }

  const actor = actorColumns(ctx);
  if (actor.userId && !contributors.has(actor.userId)) {
    contributors.set(actor.userId, null);
  }
  for (const [userId, lastMessagedAt] of contributors) {
    await tx.mutate.branchContributors.upsert({
      branchId,
      workflowId: source.workflowId,
      userId,
      lastMessagedAt,
      tenantId: ctx.tenantId,
    });
  }
}
